import React from 'react';
import axios from 'axios';

import PropTypes from 'prop-types';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Skeleton from '@mui/material/Skeleton';



const DepotGestionAutocomplete = ({ value, onChange, magasinsSeulement, required, disabled, disableClearable, autoFocus, label, plateformesSeulement, modeTri, depotsGestion, withEmpty, helperText }) => {

    const [loading, setLoading] = React.useState(true);
    const [depots, setDepots] = React.useState([]);

    const [valeur, setValeur] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');

    // Fetch des infos au chargement du composant
    React.useEffect(() => {
        const fetchData = async () => {

            await axios('api/depots-gestion')
                .then(function (response) {
                            
                    let recus = response.data;

                    if (magasinsSeulement) {
                        recus = recus.filter(depot => depot.magasin);
                    }
                    if (plateformesSeulement) {
                        recus = recus.filter(depot => depot.plateforme);
                    }

                    if (modeTri === 1) {
                        recus = recus.sort((a, b) => a.nom > b.nom);
                    }

                    if (depotsGestion.length !== 0) {
                        // On filtre sur la liste des dépôts gérés
                        recus = recus.filter(depot => depotsGestion.find(x => x.code === depot.codeDepot));
                    }

                    if (withEmpty) {
                        recus.unshift({ codeDepot: '∅', nom: 'aucun', magasin: false, plateforme: false });
                    }

                    setDepots(recus);

                    let depot = recus.find(x => x.codeDepot === value);
                    if (depot) {
                        setValeur(depot.codeDepot);
                        setInputValue(depot.codeDepot + ' - ' + depot.nom);
                    }

                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    setLoading(false);
                });

        };


        if (loading) {
            fetchData();
        }

    }, [loading, depotsGestion]);


    React.useEffect(() => {
        if (value) {
            setValeur(value);
            let depot = depots.find(x => x.codeDepot === value);
            if (depot) {
                setInputValue(depot.codeDepot + ' - ' + depot.nom);
            }
            else {
                setInputValue('');
            }
        }
        else {
            setValeur(null);
            setInputValue('');
        }
    }, [value, depots]);


    return (
        <>
            {!loading && (
                <Autocomplete
                    disablePortal
                    value={valeur}
                    onChange={(event, newValue) => {
                        onChange(event, newValue ? newValue.codeDepot : null, newValue);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason !== 'reset') {
                            setInputValue(newInputValue);
                        }
                    }}
                    options={depots}
                    renderInput={(params) => <TextField {...params} label={label} required={required} disabled={disabled} autoFocus={autoFocus} sx={{ marginTop: 1 }} helperText={helperText} />}
                    getOptionLabel={(option) => option.codeDepot + ' - ' + option.nom}
                    isOptionEqualToValue={(option, value) => value ? option.codeDepot === value : false}
                    blurOnSelect
                    disableClearable={disableClearable}
                />
            )}
            {loading && (
                <Skeleton />
            )}
        </>
     
    );
}




DepotGestionAutocomplete.propTypes = {
    required: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    disableClearable: PropTypes.bool,
    autoFocus: PropTypes.bool.isRequired,
    modeTri: PropTypes.number.isRequired,
    depotsGestion: PropTypes.array,
    withEmpty: PropTypes.bool,
    magasinsSeulement: PropTypes.bool,
    plateformesSeulement: PropTypes.bool,
    label: PropTypes.string,
    helperText: PropTypes.string,
};

DepotGestionAutocomplete.defaultProps = {
    required:false,
    disabled:false,
    disableClearable:false,
    autoFocus:false,
    modeTri: 0,
    depotsGestion: [],
    withEmpty: false,
    magasinsSeulement: false,
    plateformesSeulement: false,
    label: '',
    helperText: ''
};

export default DepotGestionAutocomplete;